import { render, staticRenderFns } from "./ProductDetailsSection.vue?vue&type=template&id=6aec35fc&"
import script from "./ProductDetailsSection.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports